<template>
  <div>
    <p class="u-mb-4">Voulez-vous vraiment supprimer votre compte ?</p>
    <div
      v-if="errorMessage"
      class="text-small is-invalid u-mb-3"
    >
      {{ errorMessage }}
    </div>
    <div class="u-d-f u-ai-c u-jc-sb">
      <ButtonSimple
        type="button"
        label="Valider la suppression"
        color="danger"
        :disabled="pending"
        @click="deleteAccount"
      />
      <ButtonSimple
        type="button"
        label="Annuler la demande"
        :disabled="pending"
        @click="vfm.closeAll()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useVfm } from 'vue-final-modal'

const vfm = useVfm()

const { data, clearToken } = useAuthState()
const { authenticated, isTemp, token, tempJWT, getAuthHeader } = useTempAuth()
const tempUser = useTempUser()

const socialStore = useSocialStore()

// the deletion takes a few seconds (confirmation e-mail): a second click
// would hit a deleted account and fail
const pending = ref(false)
const errorMessage = ref('')

// the API revokes the token of a deleted account: the session is cleared
// here, a signOut() would call /secure/logout and fail with a 401
const clearSession = () => {
  useCookie('connected').value = undefined
  tempJWT.value = undefined
  tempUser.value = undefined
  data.value = undefined
  clearToken()
  socialStore.initSocial()
}

const deleteAccount = async () => {
  pending.value = true
  errorMessage.value = ''

  try {
    await $fetch(API.DELETE__USER, {
      baseURL: useRuntimeConfig().public.wsUrl,
      method: 'DELETE',
      headers: getAuthHeader({
        authenticated,
        isTemp,
        token,
        url: API.DELETE__USER,
      }),
    })
  } catch (error) {
    console.error(error)
    errorMessage.value =
      'La suppression de votre compte a échoué, veuillez réessayer.'
    pending.value = false
    return
  }

  clearSession()
  vfm.closeAll()
  await navigateTo('/')
}
</script>
